import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import * as Theme from "../../../app/Theme";

import Info from "@material-ui/icons/Info";
import IconButton from '@material-ui/core/IconButton';

import TButton from "../../common/TButton";
import TLabel from "../../common/TLabel";
import TRadioGroup from "../../common/TRadioGroup";
import TDialog from "../../common/TDialog";

import * as rcc from "../NonVisual/RCConst";
import * as rcdu from "../NonVisual/RCDataUtil";
import RCNavBtnDiv from "../Other/RCNavBtnDiv";

import GbStdTable from "../../common/GBStdTableAG/GbStdTable";

import * as gbtc from "../../GB/GBTableConst";
import * as gbtu from "../../GB/GBTableUtil";
import {
    getDelphiHexFromHexColor,
    toBase10,
    numChanged
} from "../../GB/GBUtil";

/* Precisions --> Number of households table */
const colHeadingsRowPr_HH = 0;

const indNameColPr_HH     = 0;
const targPopColPr_HH     = 1;
const estFreqColPr_HH     = 2;
const desPrecColPr_HH     = 3;
const desEffectColPr_HH   = 4;
const numColsPr_HH        = desEffectColPr_HH + 1;

/* Precisions --> Precisions table */

const colHeadingsRow_Pr_Pr     = 0;

const indNameColPr_Pr          = 0;
const targPopColPr_Pr          = 1;
const desNumHHsColPr_Pr        = 2;
const estFreqColPr_Pr          = 3;
const desEffectColPr_Pr        = 4;
const numColsPr_Pr             = desEffectColPr_Pr + 1;

/* Power change --> Number of households table */

const colHeadingsRowPC_HH       = 0;

const indNameColPC_HH           = 0;
const targPopColPC_HH           = 1;
const estBaseFreqColPC_HH       = 2;
const estEndFreqColPC_HH        = 3;
const desEffectColPC_HH         = 4;
const numColsPC_HH              = desEffectColPC_HH  + 1;

/* Power change --> Difference table */

const colHeadingsRowPC_Df = 0;

const indNameColPC_Df            = 0;
const targPopColPC_Df            = 1;
const desNumHHsPerSurveyColPC_Df = 2;
const estFreqArm1ColPC_Df        = 3;
const estFreqArm2ColPC_Df        = 4;
const desEffectColPC_Df          = 5;
const numColsPC_Df               = desEffectColPC_Df + 1;

const dataColumnWidth = 110;

const tableMarginTop = 0;

const designEffectRDec = 2;
const estFreqRDec = 1;

class RCParametersForm extends Component {

    static propTypes = {

        targPopObjList        : PropTypes.arrayOf(PropTypes.object),
        groupObjList          : PropTypes.arrayOf(PropTypes.object),
        indicatorObjList      : PropTypes.arrayOf(PropTypes.object),
        answer1Byte           : PropTypes.number,
        answer2Byte           : PropTypes.number,
        onQ2Answered          : PropTypes.func,
        onPageChange          : PropTypes.func,
        onIndicatorDataChange : PropTypes.func,

    };

    static defaultProps = {

        targPopObjList        : {},
        groupObjList          : {},
        indicatorObjList      : {},
        onPageChange          : () => console.log("onPageChange"),
        answer1Byte           : 0,
        answer2Byte           : 0,
        onQ2Answered          : () => console.log("onQ2Answered"),
        onIndicatorDataChange : () => console.log("onIndicatorDataChange"),

    };

    state = {

        tableRef       : React.createRef(),
        showInfoDialog : false,

    };

    onInfoClick = () => {

        this.setState({

            showInfoDialog : true,

        });

    };

    onInfoDialogClose = () => {

        this.setState({

            showInfoDialog : false,

        });

    };

    onQ2RadioGroupClick = (value, info) => {

        try {

            this.props.onQ2Answered(value + 1);

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onPrecisionHHsTableChange = (newPackTable) => {

        try {

            const indicatorObjList = this.props.indicatorObjList;

            let r = 0;
            let dataType = 0;
            let value = 0;
            let indCurrID = 0;

            const value2DArray = gbtu.getPackTableValues(newPackTable);

            while ((r < value2DArray.length) && (dataType === 0)) {

                if (gbtu.getRowID(newPackTable, r) !== 0) {

                    indCurrID = gbtu.getRowID(newPackTable, r);

                    const estFreqNew = value2DArray[r][estFreqColPr_HH];
                    const desPrecNew = value2DArray[r][desPrecColPr_HH];
                    const desEffectNew = value2DArray[r][desEffectColPr_HH];

                    if (numChanged(rcdu.getIndEstFreqPr(indCurrID, indicatorObjList), estFreqNew)) {

                        dataType = rcc.estFreqDataPr_PrHH;
                        value = estFreqNew;

                    }

                    else if (numChanged(rcdu.getIndDesiredPrecPr(indCurrID, indicatorObjList), desPrecNew)) {

                        dataType = rcc.desPrecDataPr_HH;
                        value = desPrecNew;

                    }

                    else if (numChanged(rcdu.getIndDesignEffectPr(indCurrID, indicatorObjList), desEffectNew)) {

                        dataType = rcc.desEffectDataPr_PrHH;
                        value = desEffectNew;

                    }

                }

                r++;

            }

            if (dataType !== 0) {

                this.props.onIndicatorDataChange(indCurrID, dataType, value);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onPrecisionPrecTableChange = (newPackTable) => {

        try {

            const indicatorObjList = this.props.indicatorObjList;

            let r = 0;
            let dataType = 0;
            let value = 0;
            let indCurrID = 0;

            const value2DArray = gbtu.getPackTableValues(newPackTable);

            while ((r < value2DArray.length) && (dataType === 0)) {

                if (gbtu.getRowID(newPackTable, r) !== 0) {

                    indCurrID = gbtu.getRowID(newPackTable, r);

                    const desNumHHsNew = value2DArray[r][desNumHHsColPr_Pr];
                    const estFreqNew = value2DArray[r][estFreqColPr_Pr];
                    const desEffectNew = value2DArray[r][desEffectColPr_Pr];

                    if (numChanged(rcdu.getIndDesiredNumHHsPr(indCurrID, indicatorObjList), desNumHHsNew)) {

                        dataType = rcc.desNumHHsDataPr_Pr;
                        value = desNumHHsNew;

                    }

                    else if (numChanged(rcdu.getIndEstFreqPr(indCurrID, indicatorObjList), estFreqNew)) {

                        dataType = rcc.estFreqDataPr_PrHH;
                        value = estFreqNew;

                    }

                    else if (numChanged(rcdu.getIndDesignEffectPr(indCurrID, indicatorObjList), desEffectNew)) {

                        dataType = rcc.desEffectDataPr_PrHH;
                        value = desEffectNew;

                    }

                }

                r++;

            }

            if (dataType !== 0) {

                this.props.onIndicatorDataChange(indCurrID, dataType, value);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onPowerChangeHHsTableChange = (newPackTable) => {

        try {

            const indicatorObjList = this.props.indicatorObjList;

            let r = 0;
            let dataType = 0;
            let value = 0;
            let indCurrID = 0;

            const value2DArray = gbtu.getPackTableValues(newPackTable);

            while ((r < value2DArray.length) && (dataType === 0)) {

                if (gbtu.getRowID(newPackTable, r) !== 0) {

                    indCurrID = gbtu.getRowID(newPackTable, r);

                    const estBaseFreqNew = value2DArray[r][estBaseFreqColPC_HH];
                    const estEndFreqNew = value2DArray[r][estEndFreqColPC_HH];
                    const desEffectNew = value2DArray[r][desEffectColPC_HH];

                    if (numChanged(rcdu.getEstFreqBaselinePC(indCurrID, indicatorObjList), estBaseFreqNew)) {

                        dataType = rcc.estBaseFreqDataPC_HHDf;
                        value = estBaseFreqNew;

                    }

                    else if (numChanged(rcdu.getEstFreqEndlinePC(indCurrID, indicatorObjList), estEndFreqNew)) {

                        dataType = rcc.estEndFreqDataPC_HHDf;
                        value = estEndFreqNew;

                    }

                    else if (numChanged(rcdu.getIndDesignEffectPC(indCurrID, indicatorObjList), desEffectNew)) {

                        dataType = rcc.designEffectDataPC_HHDf;
                        value = desEffectNew;

                    }

                }

                r++;

            }

            if (dataType !== 0) {

                this.props.onIndicatorDataChange(indCurrID, dataType, value);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onPowerChangeDiffTableChange = (newPackTable) => {

        try {

            const indicatorObjList = this.props.indicatorObjList;

            let r = 0;
            let dataType = 0;
            let value = 0;
            let indCurrID = 0;

            const value2DArray = gbtu.getPackTableValues(newPackTable);

            while ((r < value2DArray.length) && (dataType === 0)) {

                if (gbtu.getRowID(newPackTable, r) !== 0) {

                    indCurrID = gbtu.getRowID(newPackTable, r);

                    const desNumHHsPerSurveyNew = value2DArray[r][desNumHHsPerSurveyColPC_Df];
                    const estFreqArm1New = value2DArray[r][estFreqArm1ColPC_Df];
                    const estFreqArm2New = value2DArray[r][estFreqArm2ColPC_Df];
                    const desEffectNew = value2DArray[r][desEffectColPC_Df];

                    if (numChanged(rcdu.getDesNumHHsPerSurveyPC(indCurrID, indicatorObjList), desNumHHsPerSurveyNew)) {

                        dataType = rcc.desNumHHsPerSurveyDataPC_Df;
                        value = desNumHHsPerSurveyNew;

                    }

                    else if (numChanged(rcdu.getEstFreqBaselinePC(indCurrID, indicatorObjList), estFreqArm1New)) {

                        dataType = rcc.estBaseFreqDataPC_HHDf;
                        value = estFreqArm1New;

                    }

                    else if (numChanged(rcdu.getEstFreqEndlinePC(indCurrID, indicatorObjList), estFreqArm2New)) {

                        dataType = rcc.estEndFreqDataPC_HHDf;
                        value = estFreqArm2New;

                    }

                    else if (numChanged(rcdu.getIndDesignEffectPC(indCurrID, indicatorObjList), desEffectNew)) {

                        dataType = rcc.designEffectDataPC_HHDf;
                        value = desEffectNew;

                    }

                }

                r++;

            }

            if (dataType !== 0) {

                this.props.onIndicatorDataChange(indCurrID, dataType, value);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onDownloadBtnClick = () => {

        try {

            /* Props */
            const props = this.props;
            const answer1Byte = props.answer1Byte;
            const answer2Byte = props.answer2Byte;

            let s = "";

            if (answer1Byte === rcc.precisionQ1A) {

                if (answer2Byte === rcc.numHouseholdsAQ2B) {

                    s = "Precision mode_Number of households";

                }
                else if (answer2Byte === rcc.precisionAQ2A) {

                    s = "Precision mode_Precisions";

                }

            }
            else if (answer1Byte === rcc.powerChangeQ1B) {

                if (answer2Byte === rcc.differenceBQ2B) {

                    s = "Power change mode_Difference";

                }
                else if (answer2Byte === rcc.numHouseholdsBQ2A) {

                    s = "Power change mode_Number of households";

                }

            }


            this.state.tableRef.current.exportToExcel("Parameters_" + s + ".xlsx");

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderPrecisionHHsTable = () => {

        try {

            let table = null;

            /* Props */
            const props = this.props;

            const indicatorObjList = props.indicatorObjList;
            const groupObjList = props.groupObjList;
            const targPopObjList = props.targPopObjList;

            let numRows = rcdu.getIndTableNumRows(indicatorObjList, groupObjList);

            let packTable = gbtu.getNewPackTable();
            packTable = gbtu.resizePackTable(packTable, numRows, numColsPr_HH);
            packTable = gbtu.setColWidths(packTable, dataColumnWidth);
            packTable = gbtu.setColWidth(packTable, 0, 300);
            packTable = gbtu.setColWidth(packTable, 1, 200);
            packTable = gbtu.setWordWrappedCols(packTable, true);
            packTable = gbtu.setRowAlignment(packTable, colHeadingsRowPr_HH, gbtc.hAlign.center);

            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, indNameColPr_HH, RS(SC.GB_stIndicator));
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, targPopColPr_HH, RS(SC.GB_stTargPop));
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, estFreqColPr_HH, RS(SC.GB_stEstFreq) + " (%)");
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, desPrecColPr_HH, RS(SC.GB_stDesPrecision) + " (" + RS(SC.GB_stPercPoints) + ")");
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, desEffectColPr_HH, RS(SC.GB_stDesignEffect));

            /* Can't set comments into non-data cells like header cells :-( */
            // packTable = tu.setComment(packTable, colHeadingsRowPr_HH, estFreqColPr_HH,
            //     RS(SC.GB_stEstFreqComment));
            // packTable = tu.setComment(packTable, colHeadingsRowPr_HH, desEffectColPr_HH,
            //     RS(SC.GB_stDesignEffectComment));

            let addedGroupsMstIDArray = [];
            let row = 1;

            for (let i = 1; i <= indicatorObjList.length; i++) {

                /* Only include the indicator in the table if the user wished to analyze it. */
                if (rcdu.getIndAnalyzeBool(i, indicatorObjList)) {

                    const groupCurrID = rcdu.getIndGroupCurrID(i, indicatorObjList);
                    const groupMstID = rcdu.getGroupMstID(groupCurrID, groupObjList);

                    const customIndBool = rcdu.getIndCustomBool(i, indicatorObjList);
                    const targPopType = rcdu.getIndTargPopType(i, indicatorObjList);

                    /* Write the indicator's group out first if its group has not been written out yet. */
                    if (!addedGroupsMstIDArray.includes(groupMstID)) {

                        packTable = gbtu.setValue(packTable, row, indNameColPr_HH, rcdu.getGroupName(groupCurrID, groupObjList));
                        packTable = gbtu.setIndent(packTable, row, true, 25);
                        packTable = gbtu.mergeCells(packTable, row, 0, 1, numColsPr_HH - 1);

                        addedGroupsMstIDArray.push(groupMstID);

                        for (let c = 0; c < numColsPr_HH; c++) {

                            packTable = gbtu.lockCell(packTable, row, c, true);

                        }

                        packTable = gbtu.setFontColor(packTable, row, indNameColPr_HH,
                            toBase10(getDelphiHexFromHexColor(Theme.blackColor)));

                        row++;

                    }

                    /* Now write out the indicator */
                    const indName = rcdu.getIndName(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, indNameColPr_HH, indName);

                    let paramName;
                    if (!(customIndBool && (targPopType === rcc.customTargPop))) {

                        /* Replace XX, YY, ZZ, etc. placeholders */
                        paramName = rcdu.replaceTargPopParams(
                            rcc.targPopParam, i, indicatorObjList, targPopObjList);

                    }
                    else {

                        paramName = rcdu.getIndTargPopCustomStr(i, indicatorObjList);

                    }
                    packTable = gbtu.setValue(packTable, row, targPopColPr_HH, paramName);

                    const estFreq = rcdu.getIndEstFreqPr(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, estFreqColPr_HH, estFreq);
                    packTable = gbtu.setRDec(packTable, row, estFreqColPr_HH, estFreqRDec);

                    const desPrec = rcdu.getIndDesiredPrecPr(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, desPrecColPr_HH, desPrec);

                    const designEffect = rcdu.getIndDesignEffectPr(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, desEffectColPr_HH, designEffect);
                    packTable = gbtu.setRDec(packTable, row, desEffectColPr_HH, designEffectRDec);

                    packTable = gbtu.setIndent(packTable, row, true, 50);
                    packTable = gbtu.setRowID(packTable, row, i);

                    row++;

                }

            }

            packTable = gbtu.lockCol(packTable, targPopColPr_HH, true, false);
            packTable = gbtu.setRowHeights(packTable, 50);
            packTable = gbtu.setRowHeight(packTable, 0, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, estFreqColPr_HH, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, desPrecColPr_HH, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, desEffectColPr_HH, 100);
            // Sometimes slow and cannot do this without losing the focus on the selected cell. This makes
            // navigation a pain, detracting from the user experience.
            // numRows = gbtu.getNumRows(packTable);
            // const numCols = gbtu.getNumCols(packTable);
            // for (let r = 0; r < numRows; r++) {
            //
            //     for (let c = 0; c < numCols; c++) {
            //
            //         const value = gbtu.getValue(packTable, r, c);
            //
            //         if (typeof value === "number") {
            //
            //             const numDecPlaces = gbu.decimalPlaces(value);
            //             packTable = gbtu.setRDec(packTable, r, c, numDecPlaces);
            //
            //         }
            //
            //     }
            //
            // }

            /* subheadingRowBackgroundColor = {Theme.strikemasterPurpleColor}

               subheadingRowBackgroundColor makes no sense with banding because banding is
               applied every other row.  Can we change this so that if banding is on, the "subheading"
               rows either always use the color of the banding or make it an option to do so? */
            table =
                <GbStdTable
                    headerBackgroundColor        = {Theme.RC_PalatinatePurple}
                    oddRowBackgroundColor        = {Theme.RC_LavenderBlushColor}
                    subheadingRowBackgroundColor = {"transparent"}
                    packTable                    = {packTable}
                    onPackTableChanged           = {this.onPrecisionHHsTableChange}
                    ref                          = {this.state.tableRef}
                    removedMenuNames             = {gbtc.menuItems.filter((s) => {

                        const menuItemsToRemove = gbtc.sector4_MIs.concat(
                            gbtc.sector5_MIs, gbtc.sector6_MIs
                        );

                        return menuItemsToRemove.includes(s);

                    })}
                    style                        = {{
                        marginTop : tableMarginTop,
                        //mark
                    }}
                />;

            return table;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderPrecisionPrecTable = () => {

        try {

            let table;

            /* Props */
            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const groupObjList = props.groupObjList;
            const targPopObjList = props.targPopObjList;

            let numRows = rcdu.getIndTableNumRows(indicatorObjList, groupObjList);

            let packTable = gbtu.getNewPackTable();
            packTable = gbtu.resizePackTable(packTable, numRows, numColsPr_Pr);
            packTable = gbtu.setColWidths(packTable, dataColumnWidth);
            packTable = gbtu.setColWidth(packTable, 0, 300);
            packTable = gbtu.setColWidth(packTable, 1, 200);
            packTable = gbtu.setWordWrappedCols(packTable, true);
            packTable = gbtu.setRowAlignment(packTable, colHeadingsRow_Pr_Pr, gbtc.hAlign.center);

            packTable = gbtu.setValue(packTable, colHeadingsRow_Pr_Pr, indNameColPr_Pr, RS(SC.GB_stIndicator));
            packTable = gbtu.setValue(packTable, colHeadingsRow_Pr_Pr, targPopColPr_Pr, RS(SC.GB_stTargPop));
            packTable = gbtu.setValue(packTable, colHeadingsRow_Pr_Pr, desNumHHsColPr_Pr, RS(SC.GB_stDesNumHHs));
            packTable = gbtu.setValue(packTable, colHeadingsRow_Pr_Pr, estFreqColPr_Pr, RS(SC.GB_stEstFreq) + " (%)");
            packTable = gbtu.setValue(packTable, colHeadingsRow_Pr_Pr, desEffectColPr_Pr, RS(SC.GB_stDesignEffect));

            /* Can't set comments into non-data cells like header cells :-( */
            // packTable = tu.setComment(packTable, colHeadingsRow_Pr_Pr, estFreqColPr_Pr,
            //     RS(SC.GB_stEstFreqComment));
            // packTable = tu.setComment(packTable, colHeadingsRow_Pr_Pr, desEffectColPr_Pr,
            //     RS(SC.GB_stDesignEffectComment));

            let addedGroupsMstIDArray = [];
            let row = 1;

            for (let i = 1; i <= indicatorObjList.length; i++) {

                /* Only include the indicator in the table if the user wished to analyze it. */
                if (rcdu.getIndAnalyzeBool(i, indicatorObjList)) {

                    const groupCurrID = rcdu.getIndGroupCurrID(i, indicatorObjList);
                    const groupMstID = rcdu.getGroupMstID(groupCurrID, groupObjList);

                    const customIndBool = rcdu.getIndCustomBool(i, indicatorObjList);
                    const targPopType = rcdu.getIndTargPopType(i, indicatorObjList);

                    /* Write the indicator's group out first if its group has not been written out yet. */
                    if (!addedGroupsMstIDArray.includes(groupMstID)) {

                        packTable = gbtu.setValue(packTable, row, indNameColPr_Pr, rcdu.getGroupName(groupCurrID, groupObjList));
                        packTable = gbtu.setIndent(packTable, row, true, 25);
                        packTable = gbtu.mergeCells(packTable, row, 0, 1, numColsPr_Pr - 1);

                        addedGroupsMstIDArray.push(groupMstID);

                        for (let c = 0; c < numColsPr_Pr; c++) {

                            packTable = gbtu.lockCell(packTable, row, c, true);

                        }

                        packTable = gbtu.setFontColor(packTable, row, indNameColPr_Pr,
                            toBase10(getDelphiHexFromHexColor(Theme.blackColor)));

                        row++;

                    }

                    /* Now write out the indicator */
                    const indName = rcdu.getIndName(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, indNameColPr_Pr, indName);

                    let paramName;
                    if (!(customIndBool && (targPopType === rcc.customTargPop))) {

                        /* Replace XX, YY, ZZ, etc. placeholders */
                        paramName = rcdu.replaceTargPopParams(
                            rcc.targPopParam, i, indicatorObjList, targPopObjList);

                    }
                    else {

                        paramName = rcdu.getIndTargPopCustomStr(i, indicatorObjList);

                    }
                    packTable = gbtu.setValue(packTable, row, targPopColPr_Pr, paramName);

                    const desNumHHs = rcdu.getIndDesiredNumHHsPr(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, desNumHHsColPr_Pr, desNumHHs);

                    const estFreq = rcdu.getIndEstFreqPr(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, estFreqColPr_Pr, estFreq);
                    packTable = gbtu.setRDec(packTable, row, estFreqColPr_Pr, estFreqRDec);

                    const desEffect = rcdu.getIndDesignEffectPr(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, desEffectColPr_Pr, desEffect);
                    packTable = gbtu.setRDec(packTable, row, desEffectColPr_Pr, designEffectRDec);

                    packTable = gbtu.setIndent(packTable, row, true, 50);
                    packTable = gbtu.setRowID(packTable, row, i);

                    row++;

                }

            }

            packTable = gbtu.lockCol(packTable, targPopColPr_Pr, true, false);
            packTable = gbtu.setRowHeights(packTable, 50);
            packTable = gbtu.setRowHeight(packTable, 0, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, estFreqColPr_HH, 9999999999);
            packTable = gbtu.setMaxAllowedValByCol(packTable, estFreqColPr_Pr, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, desEffectColPr_Pr, 100);
            // Sometimes slow and cannot do this without losing the focus on the selected cell. This makes
            // navigation a pain, detracting from the user experience.
            // numRows = gbtu.getNumRows(packTable);
            // const numCols = gbtu.getNumCols(packTable);
            // for (let r = 0; r < numRows; r++) {
            //
            //     for (let c = 0; c < numCols; c++) {
            //
            //         const value = gbtu.getValue(packTable, r, c);
            //
            //         if (typeof value === "number") {
            //
            //             const numDecPlaces = gbu.decimalPlaces(value);
            //             packTable = gbtu.setRDec(packTable, r, c, numDecPlaces);
            //
            //         }
            //
            //     }
            //
            // }

            /* subheadingRowBackgroundColor = {Theme.strikemasterPurpleColor}

               subheadingRowBackgroundColor makes no sense with banding because banding is
               applied every other row.  Can we change this so that if banding is on, the "subheading"
               rows either always use the color of the banding or make it an option to do so? */
            table =
                <GbStdTable
                    headerBackgroundColor        = {Theme.RC_PalatinatePurple}
                    oddRowBackgroundColor        = {Theme.RC_LavenderBlushColor}
                    subheadingRowBackgroundColor = {"transparent"}
                    packTable                    = {packTable}
                    onPackTableChanged           = {this.onPrecisionPrecTableChange}
                    ref                          = {this.state.tableRef}
                    removedMenuNames             = {gbtc.menuItems.filter((s) => {

                        const menuItemsToRemove = gbtc.sector4_MIs.concat(
                            gbtc.sector5_MIs, gbtc.sector6_MIs
                        );

                        return menuItemsToRemove.includes(s);

                    })}
                    style                        = {{
                        marginTop : tableMarginTop,
                    }}
                />;

            return table;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderPowerChangeHHsTable = () => {

        try {

            let table;

            /* Props */
            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const groupObjList = props.groupObjList;
            const targPopObjList = props.targPopObjList;

            let numRows = rcdu.getIndTableNumRows(indicatorObjList, groupObjList);

            let packTable = gbtu.getNewPackTable();
            packTable = gbtu.resizePackTable(packTable, numRows, numColsPC_HH);
            packTable = gbtu.setColWidths(packTable, dataColumnWidth);
            packTable = gbtu.setColWidth(packTable, 0, 300);
            packTable = gbtu.setColWidth(packTable, 1, 200);
            packTable = gbtu.setWordWrappedCols(packTable, true);
            packTable = gbtu.setRowAlignment(packTable, colHeadingsRowPC_HH, gbtc.hAlign.center);

            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, indNameColPC_HH , RS(SC.GB_stIndicator));
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, targPopColPC_HH , RS(SC.GB_stTargPop));
            // packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, estBaseFreqColPC_HH , RS(SC.GB_stEstBaseFreq ) + " (%)");
            // packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, estEndFreqColPC_HH , RS(SC.GB_stEstEndFreq) + " (%)");
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, estBaseFreqColPC_HH , RS(SC.GB_stEstFreq) + " - " + RS(SC.GB_stArm1) + " (%)");
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, estEndFreqColPC_HH , RS(SC.GB_stEstFreq) + " - " + RS(SC.GB_stArm2) + " (%)");
            packTable = gbtu.setValue(packTable, colHeadingsRowPr_HH, desEffectColPC_HH , RS(SC.GB_stDesignEffect));

            /* Can't set comments into non-data cells like header cells :-( */
            // packTable = tu.setComment(packTable, colHeadingsRowPr_HH, desEffectColPC_HH,
            //     RS(SC.GB_stDesignEffectComment));

            let addedGroupsMstIDArray = [];
            let row = 1;

            for (let i = 1; i <= indicatorObjList.length; i++) {

                /* Only include the indicator in the table if the user wished to analyze it. */
                if (rcdu.getIndAnalyzeBool(i, indicatorObjList)) {

                    const groupCurrID = rcdu.getIndGroupCurrID(i, indicatorObjList);
                    const groupMstID = rcdu.getGroupMstID(groupCurrID, groupObjList);
                    const groupName = rcdu.getGroupName(groupCurrID, groupObjList);

                    const customIndBool = rcdu.getIndCustomBool(i, indicatorObjList);
                    const targPopType = rcdu.getIndTargPopType(i, indicatorObjList);

                    /* Write the indicator's group out first if its group has not been written out yet. */
                    if (!addedGroupsMstIDArray.includes(groupMstID)) {

                        packTable = gbtu.setValue(packTable, row, indNameColPC_HH , groupName);
                        packTable = gbtu.setIndent(packTable, row, true, 25);
                        packTable = gbtu.mergeCells(packTable, row, 0, 1, numColsPC_HH  - 1);

                        addedGroupsMstIDArray.push(groupMstID);

                        for (let c = 0; c < numColsPC_HH ; c++) {

                            packTable = gbtu.lockCell(packTable, row, c, true);

                        }

                        packTable = gbtu.setFontColor(packTable, row, indNameColPC_HH ,
                            toBase10(getDelphiHexFromHexColor(Theme.blackColor)));

                        row++;

                    }

                    /* Now write out the indicator */
                    const indName = rcdu.getIndName(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, indNameColPC_HH, indName);

                    let paramName;
                    if (!(customIndBool && (targPopType === rcc.customTargPop))) {

                        /* Replace XX, YY, ZZ, etc. placeholders */
                        paramName = rcdu.replaceTargPopParams(
                            rcc.targPopParam, i, indicatorObjList, targPopObjList);

                    }
                    else {

                        paramName = rcdu.getIndTargPopCustomStr(i, indicatorObjList);

                    }
                    packTable = gbtu.setValue(packTable, row, targPopColPC_HH, paramName);

                    const estFreqBase = rcdu.getEstFreqBaselinePC(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, estBaseFreqColPC_HH, estFreqBase);
                    packTable = gbtu.setRDec(packTable, row, estBaseFreqColPC_HH, estFreqRDec);

                    const estFreqEnd = rcdu.getEstFreqEndlinePC(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, estEndFreqColPC_HH, estFreqEnd);
                    packTable = gbtu.setRDec(packTable, row, estEndFreqColPC_HH, estFreqRDec);

                    const designEffect = rcdu.getIndDesignEffectPC(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, desEffectColPC_HH, designEffect);
                    packTable = gbtu.setRDec(packTable, row, desEffectColPC_HH, designEffectRDec);

                    packTable = gbtu.setIndent(packTable, row, true, 50);
                    packTable = gbtu.setRowID(packTable, row, i);

                    row++;

                }

            }

            packTable = gbtu.setRowHeights(packTable, 50);
            packTable = gbtu.setRowHeight(packTable, 0, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, estBaseFreqColPC_HH, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, estEndFreqColPC_HH, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, desEffectColPC_HH, 100);
            // Sometimes slow and cannot do this without losing the focus on the selected cell. This makes
            // navigation a pain, detracting from the user experience.
            // numRows = gbtu.getNumRows(packTable);
            // const numCols = gbtu.getNumCols(packTable);
            // for (let r = 0; r < numRows; r++) {
            //
            //     for (let c = 0; c < numCols; c++) {
            //
            //         const value = gbtu.getValue(packTable, r, c);
            //
            //         if (typeof value === "number") {
            //
            //             const numDecPlaces = gbu.decimalPlaces(value);
            //             packTable = gbtu.setRDec(packTable, r, c, numDecPlaces);
            //
            //         }
            //
            //     }
            //
            // }

            /* subheadingRowBackgroundColor = {Theme.strikemasterPurpleColor}

               subheadingRowBackgroundColor makes no sense with banding because banding is
               applied every other row.  Can we change this so that if banding is on, the "subheading"
               rows either always use the color of the banding or make it an option to do so? */
            table =
                <GbStdTable
                    headerBackgroundColor        = {Theme.RC_PalatinatePurple}
                    oddRowBackgroundColor        = {Theme.RC_LavenderBlushColor}
                    subheadingRowBackgroundColor = {"transparent"}
                    packTable                    = {packTable}
                    onPackTableChanged           = {this.onPowerChangeHHsTableChange}
                    ref                          = {this.state.tableRef}
                    removedMenuNames             = {gbtc.menuItems.filter((s) => {

                        const menuItemsToRemove = gbtc.sector4_MIs.concat(
                            gbtc.sector5_MIs, gbtc.sector6_MIs
                        );

                        return menuItemsToRemove.includes(s);

                    })}
                    style                        = {{
                        marginTop : tableMarginTop,
                    }}
                />;

            return table;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderPowerChangeDiffTable = () => {

        try {

            let table;

            /* Props */
            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const groupObjList = props.groupObjList;
            const targPopObjList = props.targPopObjList;

            let numRows = rcdu.getIndTableNumRows(indicatorObjList, groupObjList);

            let packTable = gbtu.getNewPackTable();
            packTable = gbtu.resizePackTable(packTable, numRows, numColsPC_Df);
            packTable = gbtu.setColWidths(packTable, dataColumnWidth);
            packTable = gbtu.setColWidth(packTable, 0, 300);
            packTable = gbtu.setColWidth(packTable, 1, 200);
            packTable = gbtu.setWordWrappedCols(packTable, true);
            packTable = gbtu.setRowAlignment(packTable, colHeadingsRowPC_Df, gbtc.hAlign.center);

            packTable = gbtu.setValue(packTable, colHeadingsRowPC_Df, indNameColPC_Df, RS(SC.GB_stIndicator));
            packTable = gbtu.setValue(packTable, colHeadingsRowPC_Df, targPopColPC_Df, RS(SC.GB_stTargPop));
            packTable = gbtu.setValue(packTable, colHeadingsRowPC_Df, desNumHHsPerSurveyColPC_Df, RS(SC.GB_stDesHHsPerSurvey));
            packTable = gbtu.setValue(packTable, colHeadingsRowPC_Df, estFreqArm1ColPC_Df, RS(SC.GB_stEstFreq) + " - " + RS(SC.GB_stArm1) + " (%)");
            packTable = gbtu.setValue(packTable, colHeadingsRowPC_Df, estFreqArm2ColPC_Df, RS(SC.GB_stEstFreq) + " - " + RS(SC.GB_stArm2) + " (%)");
            packTable = gbtu.setValue(packTable, colHeadingsRowPC_Df, desEffectColPC_Df, RS(SC.GB_stDesignEffect));

            /* Can't set comments into non-data cells like header cells :-( */
            // packTable = tu.setComment(packTable, colHeadingsRowPC_Df, desEffectColPC_Df,
            //     RS(SC.GB_stDesignEffectComment));

            let addedGroupsMstIDArray = [];
            let row = 1;

            for (let i = 1; i <= indicatorObjList.length; i++) {

                /* Only include the indicator in the table if the user wished to analyze it. */
                if (rcdu.getIndAnalyzeBool(i, indicatorObjList)) {

                    const groupCurrID = rcdu.getIndGroupCurrID(i, indicatorObjList);
                    const groupMstID = rcdu.getGroupMstID(groupCurrID, groupObjList);
                    const groupName = rcdu.getGroupName(groupCurrID, groupObjList);

                    const customIndBool = rcdu.getIndCustomBool(i, indicatorObjList);
                    const targPopType = rcdu.getIndTargPopType(i, indicatorObjList);

                    /* Write the indicator's group out first if its group has not been written out yet. */
                    if (!addedGroupsMstIDArray.includes(groupMstID)) {

                        packTable = gbtu.setValue(packTable, row, indNameColPC_Df, groupName);
                        packTable = gbtu.setIndent(packTable, row, true, 25);
                        packTable = gbtu.mergeCells(packTable, row, 0, 1, numColsPC_Df - 1);

                        addedGroupsMstIDArray.push(groupMstID);

                        for (let c = 0; c < numColsPC_Df; c++) {

                            packTable = gbtu.lockCell(packTable, row, c, true);

                        }

                        packTable = gbtu.setFontColor(packTable, row, indNameColPC_Df,
                            toBase10(getDelphiHexFromHexColor(Theme.blackColor)));

                        row++;

                    }

                    /* Now write out the indicator */

                    const indName = rcdu.getIndName(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, indNameColPC_Df, indName);

                    let paramName;
                    if (!(customIndBool && (targPopType === rcc.customTargPop))) {

                        /* Replace XX, YY, ZZ, etc. placeholders */
                        paramName = rcdu.replaceTargPopParams(
                            rcc.targPopParam, i, indicatorObjList, targPopObjList);

                    }
                    else {

                        paramName = rcdu.getIndTargPopCustomStr(i, indicatorObjList);

                    }
                    packTable = gbtu.setValue(packTable, row, targPopColPC_Df, paramName);

                    const desNumHHsPerSurvey = rcdu.getDesNumHHsPerSurveyPC(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, desNumHHsPerSurveyColPC_Df, desNumHHsPerSurvey);

                    const estFreqArm1 = rcdu.getEstFreqBaselinePC(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, estFreqArm1ColPC_Df, estFreqArm1);
                    packTable = gbtu.setRDec(packTable, row, estFreqArm1ColPC_Df, estFreqRDec);

                    const estFreqArm2 = rcdu.getEstFreqEndlinePC(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, estFreqArm2ColPC_Df, estFreqArm2);
                    packTable = gbtu.setRDec(packTable, row, estFreqArm2ColPC_Df, estFreqRDec);

                    const designEffect = rcdu.getIndDesignEffectPC(i, indicatorObjList);
                    packTable = gbtu.setValue(packTable, row, desEffectColPC_Df, designEffect);
                    packTable = gbtu.setRDec(packTable, row, desEffectColPC_Df, designEffectRDec);

                    packTable = gbtu.setIndent(packTable, row, true, 50);
                    packTable = gbtu.setRowID(packTable, row, i);

                    row++;

                }

            }

            packTable = gbtu.setComment(packTable, 1, 4,
                RS(SC.GB_stDesignEffectComment));

            packTable = gbtu.setRowHeights(packTable, 50);
            packTable = gbtu.setRowHeight(packTable, 0, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, desNumHHsPerSurveyColPC_Df, 9999999999);
            packTable = gbtu.setMaxAllowedValByCol(packTable, estFreqArm1ColPC_Df, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, estFreqArm2ColPC_Df, 100);
            packTable = gbtu.setMaxAllowedValByCol(packTable, desEffectColPC_Df, 100);
            // Sometimes slow and cannot do this without losing the focus on the selected cell. This makes
            // navigation a pain, detracting from the user experience.
            // numRows = gbtu.getNumRows(packTable);
            // const numCols = gbtu.getNumCols(packTable);
            // for (let r = 0; r < numRows; r++) {
            //
            //     for (let c = 0; c < numCols; c++) {
            //
            //         const value = gbtu.getValue(packTable, r, c);
            //
            //         if (typeof value === "number") {
            //
            //             const numDecPlaces = gbu.decimalPlaces(value);
            //             packTable = gbtu.setRDec(packTable, r, c, numDecPlaces);
            //
            //         }
            //
            //     }
            //
            // }

            /* subheadingRowBackgroundColor = {Theme.strikemasterPurpleColor}

               subheadingRowBackgroundColor makes no sense with banding because banding is
               applied every other row.  Can we change this so that if banding is on, the "subheading"
               rows either always use the color of the banding or make it an option to do so? */
            table =
                <GbStdTable
                    headerBackgroundColor        = {Theme.RC_PalatinatePurple}
                    oddRowBackgroundColor        = {Theme.RC_LavenderBlushColor}
                    subheadingRowBackgroundColor = {"transparent"}
                    packTable                    = {packTable}
                    onPackTableChanged           = {this.onPowerChangeDiffTableChange}
                    ref                          = {this.state.tableRef}
                    removedMenuNames             = {gbtc.menuItems.filter((s) => {

                        const menuItemsToRemove = gbtc.sector4_MIs.concat(
                            gbtc.sector5_MIs, gbtc.sector6_MIs
                        );

                        return menuItemsToRemove.includes(s);

                    })}
                    style                        = {{
                        marginTop : tableMarginTop,
                    }}
                />;

            return table;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    render() {

        /* Props */
        const props = this.props;
        const onPageChange = props.onPageChange;
        const answer1Byte = props.answer1Byte;
        const answer2Byte = props.answer2Byte;

        /* state */

        const state = this.state;
        const showInfoDialog = state.showInfoDialog;

        let q2String = RS(SC.GB_stEnterParamsFor);
        let q2OptionsStrArray = ["", ""];
        if (answer1Byte === rcc.precisionQ1A) {

            q2OptionsStrArray = [RS(SC.GB_stPrecisions), RS(SC.GB_stNumHHs)];

        }
        else {

            q2OptionsStrArray = [RS(SC.GB_stNumHHs), RS(SC.GB_stDifference)];

        }

        const q2Label =
            <TLabel
                caption = {q2String}
                style   = {{
                    color      : Theme.RC_HippieBlue,
                    display    : "inline-block",
                    fontWeight : "bold",
                    marginLeft : 10,
                }}
            />;

        const q2RadioGroup =
            <TRadioGroup
                handleChange     = {this.onQ2RadioGroupClick}
                itemIndex        = {answer2Byte - 1}
                items            = {q2OptionsStrArray}
                radioButtonColor = {"secondary"}
                row              = {true}
                style = {{
                    display      : "block",
                    marginLeft   : 20,
                }}
            />;

        let editorTable = null;
        let showEstFreqComment = false;
        let showDesEffectComment = true;

        if (answer1Byte === rcc.precisionQ1A) {

            if (answer2Byte === rcc.numHouseholdsAQ2B) {

                showEstFreqComment = true;
                editorTable = this.renderPrecisionHHsTable();

            }
            else if (answer2Byte === rcc.precisionAQ2A) {

                editorTable = this.renderPrecisionPrecTable();

            }

        }
        else if (answer1Byte === rcc.powerChangeQ1B) {

            if (answer2Byte === rcc.differenceBQ2B) {

               editorTable = this.renderPowerChangeDiffTable();

            }
            else if (answer2Byte === rcc.numHouseholdsBQ2A) {

                editorTable = this.renderPowerChangeHHsTable();

            }

        }

        let infoBtn = null;

        if (showEstFreqComment || showDesEffectComment){

            infoBtn =
                <IconButton
                    onClick = {this.onInfoClick}
                    style   = {{
                        color        : Theme.RC_SecondaryColor,
                        cursor       : "pointer",
                        //mark
                        display      : "inline-block",
                        padding      : 0,
                    }}
                >
                    <Info
                        style = {{
                            color : Theme.RC_SecondaryColor,
                        }}
                    />
                </IconButton>;

        }

        let infoDialog = null;

        if (showInfoDialog) {

            const header =
                <p
                    key   = {"header_p"}
                    style = {{
                        ...Theme.labelStyle,
                        padding : 0,
                        margin  : 0,
                    }}
                >
                    {RS(SC.GB_stInformation)}
                </p>;

            let contentArray = [];

            if (showEstFreqComment) {

                const estFreqHeader =
                    <p
                        key   = {"text_p"}
                        style = {{
                            ...Theme.labelFontStyle,
                            fontWeight : "bold",
                            margin     : 0,
                            padding    : 0,
                        }}
                    >
                        {RS(SC.GB_stEstFreq)}
                    </p>;

                contentArray.push(estFreqHeader);

                const estFreqText =
                    <p
                        key   = {"text_p"}
                        style = {{
                            ...Theme.labelFontStyle,
                            margin    : 0,
                            marginTop : 10,
                            padding   : 0,
                        }}
                    >
                        {RS(SC.GB_stEstFreqComment)}
                    </p>;

                contentArray.push(estFreqText);

            }

            if (showDesEffectComment) {

                const desEffectHeader =
                    <p
                        key   = {"text_p"}
                        style = {{
                            ...Theme.labelFontStyle,
                            fontWeight : "bold",
                            margin     : 0,
                            marginTop  : (contentArray.length > 0) ? 20 : 0,
                            padding    : 0,
                        }}
                    >
                        {RS(SC.GB_stDesignEffect)}
                    </p>;

                contentArray.push(desEffectHeader);

                const desEffectText =
                    <p
                        key   = {"text_p"}
                        style = {{
                            ...Theme.labelFontStyle,
                            margin    : 0,
                            marginTop : 10,
                            padding   : 0,

                        }}
                    >
                        {RS(SC.GB_stDesignEffectComment)}
                    </p>;

                contentArray.push(desEffectText);

            }

            infoDialog =
                <TDialog
                    actions = {['mrClose']}
                    content = {contentArray}
                    header  = {[header]}
                    key     = {"infoDialog"}
                    onClose = {this.onInfoDialogClose}
                />;

        }

        const downloadBtn =
            <TButton
                caption        = {RS(SC.GB_stDownloadTable)}
                captionStyles  = {{
                    fontSize     : 16,
                    ...Theme.labelFontStyle,
                    marginTop    : 5,
                    marginBottom : 5,
                }}
                containerStyle = {{
                    display      : "inline-block",
                    fontFamily   : Theme.fontFamily,
                    //marginBottom : 20,
                    marginLeft   : Theme.leftIndent,
                    marginRight  : 40,
                    //marginTop    : Theme.topIndent,
                }}
                key            = {"downloadBtn"}
                style          = {{
                    backgroundColor : Theme.RC_PrimaryColor,
                    fontFamily      : Theme.fontFamily,
                }}
                onClick        = {this.onDownloadBtnClick}
            />;

        const navBtnDiv =
            <RCNavBtnDiv
                divStyle       = {{
                    display   : "inline-block",
                }}
                onBackBtnClick = {() => onPageChange(rcc.assignTargPopsForm)}
                onNextBtnClick = {() => onPageChange(rcc.resultsForm)}
            />;

        return (

            <React.Fragment>

                <div
                    className = {"upperDiv"}
                    key       = {"upperDiv"}
                    style     = {{
                        margin : Theme.leftIndent,
                    }}
                >
                    <div
                        style = {{
                            display        : "flex",
                            justifyContent : "baseline",
                        }}
                    >
                        {infoBtn}
                        {q2Label}
                    </div>
                    {q2RadioGroup}
                    {editorTable}
                </div>

                {navBtnDiv}
                {downloadBtn}
                {infoDialog}

            </React.Fragment>

        );

    }

}

export default RCParametersForm;
